import React from "react";
import { useTranslation } from "react-i18next";

const CATEGORY_COLORS = {
  Safe: "#2ecc71",
  Favourable: "#27ae60",
  BattleGround: "#f1c40f",
  Difficult: "#e67e22",
  "Very Difficult": "#e74c3c",
};

const FavourabilityLegend = () => {
  const { t } = useTranslation();
  return (
    <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-md border border-gray-200 rounded-xl shadow-lg px-3 py-2 z-[9999]">
      <div className="text-sm font-semibold text-[#123865] mb-2">
         {t("favourabilityLegend")}
      </div>

      <div className="space-y-1">
        {Object.entries(CATEGORY_COLORS).map(([label, color]) => (
          <div key={label} className="flex items-center gap-2 text-xs">
            <span
              className="w-3 h-3 rounded-sm"
              style={{ backgroundColor: color }}
            />
            <span className="text-gray-700">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FavourabilityLegend;
